module.exports = __webpack_public_path__ + "img/geography.6f4c38a4.png";